import React, { createContext, useState, useContext, ReactNode } from 'react';

// Define the layout types
type Layout = 'modular' | 'hawk eye';

type LayoutContextType = {
  layout: Layout;
  setLayout: (newLayout: Layout) => void;
};

const LayoutContext = createContext<LayoutContextType | undefined>(undefined);

interface LayoutProviderProps {
  children: ReactNode;
}

export const LayoutProvider: React.FC<LayoutProviderProps> = ({ children }) => {
  const [layout, setLayoutState] = useState<Layout>('modular');

  const setLayout = (newLayout: Layout) => {
    setLayoutState(newLayout);
  };

  return (
    <LayoutContext.Provider value={{ layout, setLayout }}>
      {children}
    </LayoutContext.Provider>
  );
};

export const useLayout = () => {
  const context = useContext(LayoutContext);
  if (!context) {
    throw new Error('useLayout must be used within a LayoutProvider');
  }
  return context;
};
